/** @jsx jsx */
import { css, jsx } from '@emotion/react'
import { CSSProperties } from 'react'
import { StartGuide } from '../admin/facility_detail_form/StartGuide'
import { BaseContainer } from './Base'
import { FixRequestLink } from './FixRequestLink'
import { Header } from './Header'
import { Item } from './Item'
import { ItemsForChild } from './ItemsForChild'
import { ItemsForRegistration } from './ItemsForRegistration'
import { ItemsForSubmittion } from './ItemsForSubmittion'
import { StartFlow } from './StartFlow'
import { UsageFlow, UsageFlowItem } from './UsageFlow'
import { VStack } from './VStack'

export type UsageGuideTemplateProps = {
  startGuide: StartGuide
  usageFlowPreviousDay: UsageFlowItem[]
  usageFlowThatDay: UsageFlowItem[]
  usageCautions: string[]
  itemsForRegistration: Item[]
  itemsForSubmittion: Item[]
  itemsForChild: Item[]
  onBack: (e: any) => void
  style?: CSSProperties
  disableHeader?: boolean
}

export const UsageGuideTemplate = ({
  startGuide,
  usageFlowPreviousDay,
  usageFlowThatDay,
  usageCautions,
  itemsForRegistration,
  itemsForSubmittion,
  itemsForChild,
  onBack,
  style,
  disableHeader,
}: UsageGuideTemplateProps) => {
  return (
    <BaseContainer css={usageGuideTemplateStyle} style={style}>
      {!disableHeader && (
        <Header title="ご利用方法・持ちもの" onBack={onBack} />
      )}
      <h2>✏ 施設への登録</h2>
      <VStack gap="15px" style={{ padding: '30px 15px 0px' }}>
        <StartFlow blocks={startGuide} />
        <ItemsForRegistration items={itemsForRegistration} />
      </VStack>
      <h2>👶 お預かりの流れ</h2>
      <div style={{ padding: '30px 15px 0px' }}>
        <UsageFlow
          previousDay={usageFlowPreviousDay}
          thatDay={usageFlowThatDay}
          cautions={usageCautions}
        />
      </div>
      <h2 id="required-bringing">👜 利用当日の持ちもの</h2>
      <VStack gap="15px" style={{ margin: '30px 15px 0px' }}>
        <ItemsForSubmittion items={itemsForSubmittion} />
        <ItemsForChild items={itemsForChild} />
      </VStack>
      <div
        style={{
          padding: '30px 20px 30px',
        }}
      >
        <FixRequestLink>情報の修正を提案</FixRequestLink>
      </div>
    </BaseContainer>
  )
}

const usageGuideTemplateStyle = css`
  h2 {
    font-size: 18px;
    line-height: 100%;
    text-align: center;
    letter-spacing: 0.05em;

    &:first-of-type {
      margin-top: 43px;
    }

    &:not(:first-of-type) {
      border-top: 1px solid #edeceb;
      padding-top: 30px;
      margin-top: 30px;
    }
  }
`
